import { useCountriesOptions } from "@vega-api/custom";
import { Dropdown } from "@vega-core/components/Form/Controls/Dropdown/Dropdown/Dropdown";
import { FormLabel } from "@vega-core/components/Form/Layout/FormLabel";
import { StyledPlaceholder } from "@vega-core/components/Loaders/StyledPlaceholder";
import type { OptionType } from "@vega-core/models/options";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type Props = {
  error?: string;
  isOptional?: boolean;
  label?: string | null;
  onChange: (value: OptionType) => void;
  placeholder: string;
  tooltipContent?: string;
  value?: string; // from now on it's always alpha2 code
  fullWidth?: boolean;
  constrainInputWidth?: boolean;
};

export function CountrySelector({
  error,
  isOptional,
  label,
  onChange,
  placeholder,
  value,
  tooltipContent,
  fullWidth,
  constrainInputWidth = false,
}: Props) {
  const { countries } = useCountriesOptions();

  return (
    <div className={cnTwMerge("flex flex-col", fullWidth && "w-full")}>
      <div
        className={cnTwMerge(
          "flex items-center justify-between",
          fullWidth && "w-full",
        )}
      >
        <div
          className={cnTwMerge("flex items-center justify-center gap-1 w-full")}
        >
          <FormLabel
            isOptional={isOptional}
            label={label}
            tooltipContent={tooltipContent}
          />
        </div>
      </div>
      {countries.length > 0 ? (
        <Dropdown
          constrainInputWidth={constrainInputWidth}
          error={error}
          fullWidth={fullWidth}
          isSearchable
          name="countrySelector"
          onChange={(value) => onChange(value)}
          options={countries}
          placeholder={placeholder}
          value={value}
        />
      ) : (
        <StyledPlaceholder
          className="flex h-12 w-[100%] items-center"
          text={m.btn_loading()}
        />
      )}
    </div>
  );
}
